export function mapDataForBackend(user) {
  return {
    email: user.email,
    role: user.role === 'admin' ? 'user' : 'admin',
  };
}

